import { render, staticRenderFns } from "./DietaryRecallCard.vue?vue&type=template&id=0c0da23e&scoped=true"
import script from "./DietaryRecallCard.vue?vue&type=script&lang=js"
export * from "./DietaryRecallCard.vue?vue&type=script&lang=js"
import style0 from "./DietaryRecallCard.vue?vue&type=style&index=0&id=0c0da23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0da23e",
  null
  
)

export default component.exports